module.exports={labels:["上場","非上場"],values:[10,22]};